module.exports = __webpack_public_path__ + "static/media/villa-azul-1.aaf9e91d.webp";